import React from "react";

const NewPatientInfo = () => {
  return (
    <React.Fragment>
      <span className="eyebrow">New Patients</span>
      <h1>Welcome to Your First Visit</h1>
      <p className="lead">
        Dr. Bellamy and staff look forward to meeting you and determining your
        individual needs. Upon arrival, most new patients can expect the
        following:
      </p>

      <ul className="checklist">
        <li>Meet Dr. Bellamy and the team</li>
        <li>
          A complete series of dental x-rays (usually good for 3–5 years) to
          check for decay, bone loss, and other anomalies
        </li>
        <li>
          A review of your health history, including surgeries, medications, and
          allergies
        </li>
        <li>A periodontal evaluation to assess for gum disease</li>
        <li>Oral cancer screening</li>
        <li>Evaluation of existing restorations</li>
        <li>
          Evaluation of tooth decay through x-rays, visual exam, and Diagnodent
        </li>
        <li>Discussion of your needs and concerns</li>
        <li>Insurance &amp; payment options</li>
      </ul>

      <div className="new-patient-cta">
        <a
          className="button button--big"
          href="https://forms.mydentistlink.com/594cb35d-3be3-4283-af5d-294164f49a3d"
          target="_blank"
          rel="noreferrer"
        >
          Complete New Patient Forms
        </a>
        <p>
          We recommend completing our new patient forms prior to your first
          visit. If you have any questions about the information requested,
          please feel free to contact us during normal business hours.
        </p>
      </div>
    </React.Fragment>
  );
};

export default NewPatientInfo;
